<template>
  <div class="contais">
    <div class="header">
      <!-- 左边的搜索栏 -->
      <div class="header_left">
        <!-- <div class="Search">
                    <el-date-picker v-model="inputDate" type="date" placeholder="选择赎当日期搜索" value-format="yyyy-MM-dd"></el-date-picker>
                     <el-button type="primary" @click="QueryDate">{{isQueryDate==true?'搜索中...':'搜索'}}</el-button>
                </div> -->
        <div class="Search">
          <el-input v-model="inputName" placeholder="请输入当户姓名"></el-input>
          <!-- <input type="text" class="inputText"> -->
          <el-button type="primary" @click="QueryName(inputName)">{{
            isNameQuery == true ? "搜索中..." : "搜索"
          }}</el-button>
        </div>
      </div>
      <!-- 右边显示在当业务数量 -->
      <div class="header_right">
        <div class="header_right_a">
          <span>今日绝当：{{ DayTableData }}</span>
          <span>金额：{{ DayDataPrice }}元</span>
        </div>
        <div class="header_right_a">
          <span>全部绝当：{{ Total }}</span>
          <span>金额：{{ SumPrice }}元</span>
        </div>
      </div>
    </div>

    <!-- 内容列表 -->
    <div class="content">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="绝当待确认" name="first">
          <div>
            <el-table
              :data="SData"
              border
              style="width: 100%"
            >
              <el-table-column prop="CreateDate" label="建档日期" width="180">
              </el-table-column>
              <el-table-column prop="Piaonumber" label="票号" width="180">
              </el-table-column>
              <el-table-column prop="Dhname" label="当户姓名"> </el-table-column>
              <el-table-column prop="Ddedquota" label="典当额度"> </el-table-column>
              <el-table-column prop="DdqxStartDate" label="典当开始日期">
              </el-table-column>
              <el-table-column prop="DdqxEndDate" label="典当到期日期"> </el-table-column>
              <el-table-column prop="ZhfPrice" label="典当综合费"> </el-table-column>
              <el-table-column prop="lx" label="典当利息"> </el-table-column>
              <el-table-column prop="Fcaddres" label="房产地址"> </el-table-column>
              <el-table-column prop="DyfsGuaranty" label="抵押方式"> </el-table-column>
              <el-table-column prop="CreateUser" label="经办人"> </el-table-column>
              <el-table-column prop="Review" label="复核"> </el-table-column>
              <el-table-column prop="Finance" label="财务"> </el-table-column>
              <el-table-column
                fixed="left"
                label="操作"
                width="100">
                <template slot-scope="scope">
                    <el-button @click="JClick(scope.row)" type="text" size="small">确定绝当</el-button>
                </template>
             </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="绝当业务" name="second">
            <div>
            <el-table
              :data="tableData"
              border
              style="width: 100%"
            >
              <el-table-column prop="CreateDate" label="建档日期" width="180">
              </el-table-column>
              <el-table-column prop="Piaonumber" label="票号" width="180">
              </el-table-column>
              <el-table-column prop="Dhname" label="当户姓名"> </el-table-column>
              <el-table-column prop="Ddedquota" label="典当额度"> </el-table-column>
              <el-table-column prop="DdqxStartDate" label="典当开始日期">
              </el-table-column>
              <el-table-column prop="DdqxEndDate" label="典当到期日期"> </el-table-column>
              <el-table-column prop="ZhfPrice" label="典当综合费"> </el-table-column>
              <el-table-column prop="lx" label="典当利息"> </el-table-column>
              <el-table-column prop="Fcaddres" label="房产地址"> </el-table-column>
              <el-table-column prop="DyfsGuaranty" label="抵押方式"> </el-table-column>
              <el-table-column prop="CreateUser" label="经办人"> </el-table-column>
              <el-table-column prop="Review" label="复核"> </el-table-column>
              <el-table-column prop="Finance" label="财务"> </el-table-column>
            </el-table>

            </div>
        </el-tab-pane>

        <!-- 搜索结果 -->
         <el-tab-pane label="搜索结果" name="QueryData">
           <div>
            <el-table
              :data="QueryData"
              border
              style="width: 100%"
            >
              <el-table-column prop="CreateDate" label="建档日期" width="180">
              </el-table-column>
              <el-table-column prop="Piaonumber" label="票号" width="180">
              </el-table-column>
              <el-table-column prop="Dhname" label="当户姓名"> </el-table-column>
              <el-table-column prop="Ddedquota" label="典当额度"> </el-table-column>
              <el-table-column prop="DdqxStartDate" label="典当开始日期">
              </el-table-column>
              <el-table-column prop="DdqxEndDate" label="典当到期日期"> </el-table-column>
              <el-table-column prop="ZhfPrice" label="典当综合费"> </el-table-column>
              <el-table-column prop="lx" label="典当利息"> </el-table-column>
              <el-table-column prop="Fcaddres" label="房产地址"> </el-table-column>
              <el-table-column prop="DyfsGuaranty" label="抵押方式"> </el-table-column>
              <el-table-column prop="CreateUser" label="经办人"> </el-table-column>
              <el-table-column prop="Review" label="复核"> </el-table-column>
              <el-table-column prop="Finance" label="财务"> </el-table-column>
            </el-table>
           </div>
         </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "pawnhouse",
  data() {
    return {
      DayTableData: 0, //今日绝当数据
      DayDataPrice: 0, //今日绝当金额

      Total: 0, //全部绝当数量
      SumPrice: 0, //全部绝当金额

      isNameQuery: false, //搜索按钮
      inputName: "", //名字搜索栏的默认值

      activeName: "first",
      Jdate: "", //绝当日期

      tableData:[], //绝当待确认的数据
      SData:[], //总绝当数据
      QueryData:[], //搜索出来的数据

      Date:'', //今天的日期
      UserName:'', //当前登录的用户


    };
  },
  methods: {
    //名字搜索
    QueryName(event) {
      this.activeName = 'QueryData'

      if(event!==""){
         this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").where({Review:_.neq(""),State:"绝当",Dhname:_.eq("${event}")}).limit(1000).get()`,
        }).then(res=>{
          res.data.data.forEach((element,index,array)=>{
            array[index] = JSON.parse(element)
          })
          this.QueryData = res.data.data
        })
      }else{
        this.$message({
          message: '请输入当户名字在搜索',
          type: 'warning'
        });
      }

      
     
    },

    //请求全部绝当数据
    getData() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").where({Review:_.neq(""),State:"绝当"}).limit(1000).get()`,
        })
        .then((res) => {
            res.data.data.forEach((element,index,array)=>{
                array[index] = JSON.parse(element)
            })
   
          this.Total = res.data.pager.Total;

          this.tableData = res.data.data

          this.SumPrice = this.Sum(res.data.data)

          
        });
    },
    //请求绝当数据待确认数据
    getJdata() {
      this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("house").where({Review:_.neq(""),State:"在当",DdqxEndDate:_.lte("${this.Jdate}")}).limit(1000).get()`,
        })
        .then((res) => {
          res.data.data.forEach((element, index, array) => {
            array[index] = JSON.parse(element);
          });

          this.SData = res.data.data
        });
    },

    //tab标签卡的切换事件
    handleClick(event) {
 
      if(event.index == 0){
          //请求绝当待确认的数据
          this.getJdata()
      }else{
          //否则就是请求已经确认的绝当数据
          this.getData()
      }
    },

    //确定绝当操作
    JClick(event){
       
        this.$confirm(`是否将${event.Dhname}的业务确定绝当吗?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            //确定绝当
            this.confirm(event)
          
        }).catch(() => {
            //取消绝当
          this.$message({
            type: 'info',
            message: '已取消绝当'
          });          
        });
    },
    confirm(event){
            //绝当执行
             this.axios
          .post("/api/tcb/databaseupdate?access_token=" + this.ACCESS_TOKEN, {
            env: `${this.userData.env}`,
            query:
              `db.collection("house").doc("${event._id}").update({data:{State:"绝当"}})`,
          }).then(res=>{
              if(res.data.errcode == 0){
                  this.addData(event)
              }else{
                   this.$notify({
                        title: '绝当操作失败',
                        message: res.data.esrrmg,
                        type: 'warning'
                    });
              }
              
          })
    },
    //添加流水
    addData(event){

             this.axios
        .post("/api/tcb/databaseadd?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").add({data:{name:"${
            event.Dhname
          }",xuday:"${this.Date}",cardnumber:"${event.Cardnumber}",itemname:"房产-${event.TxqzWarrant}",
            ticketnumber:"${event.Piaonumber}",telnumber:"${
            event.tel
          }",startdate:"${event.DdqxStartDate}",xupri:"/",
            enddate:"${event.DdqxEndDate}",dday:"/",xuname:"${
            this.UserName
          }",overdate:"${event.DdqxStartDate}",ytdy:"${dayjs().diff(event.DdqxEndDate,'day')}",pena:"0",rece:"/",yspri:"${event.Ddedquota}",stas:"绝当",pri:"${event.Ddedquota}",lx:"/",couqons:"线下不适用",couqonmoney:"0",xnumber:""}})`,
        }).then(()=>{
              this.$notify({
                        title: `绝当操作成功`,
                        message: `当户 ${event.Dhname} 典当业务已确认绝当`,
                        type: 'success'
                    });

                    setTimeout(()=>{
                        this.$router.go(0);
                    },1000)
        })
    },
    //计算总金额
    Sum(event){
         let price = ''
              for (let i in event) {
                price += event[i].Ddedquota;
                price += "+";
              }
              price = price.substring(0, price.length - 1);
              return eval(price) || 0;       
    },

    //今日绝当的业务
    getDayData(){
         this.axios
        .post("/api/tcb/databasequery?access_token=" + this.ACCESS_TOKEN, {
          env: `${this.userData.env}`,
          query: `db.collection("yxus_record").where({stas:"绝当",xuday:"${this.Date}"}).limit(1000).get()`,
        }).then(res=>{
            res.data.data.forEach((element,index,array)=>{
                array[index] = JSON.parse(element)
            })

            let DayData = res.data.data.filter(item=>{
              return item.itemname.substr(0, 2) == '房产'
            })

            this.DayTableData = DayData.length


            let price = ''
              for (let i in DayData) {
                price += DayData[i].pri;
                price += "+";
              }
              price = price.substring(0, price.length - 1);
              this.DayDataPrice =  eval(price) || 0;
            
        })
    }

  },
  created() {
    //获取到this.ACCESS_TOKEN
    this.getTokens();

    //获取当前登录的用户数据
    this.getUserToken();

    //绝当的日期
    this.Jdate = dayjs().subtract(5, "day").format("YYYY-MM-DD");
    //今日的日期
    this.Date = dayjs().format("YYYY-MM-DD")


  },
  mounted() {
    setTimeout(() => {
      this.getData();
      if (this.activeName == "first") {
        this.getJdata();
      }
      this.UserName = this.userData.username

      this.getDayData()
    }, 800);
  },
};
</script>
<style scoped>
.header {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.header_left {
  width: 60%;
  height: 172px;
  background: #ffffff;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.header_right {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  width: 38%;
  height: 172px;
  background: #ffffff;
}

.header_right_a {
  width: 40%;
  height: 60%;
  background: #4f92d1;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 22px;
  font-weight: bolder;
}
.content {
  margin: 20px auto;
  width: 100%;
  /* height: 500px; */
  background: #ffffff;
}
.Search {
  width: 40%;
  height: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
}
.content {
  width: 100%;
  height: 500px;
  background: #ffffff;
}
</style>
